import { ArrowLeftOutlined } from "@ant-design/icons";
import { Image, Tag } from "antd";
import "./css/inspiration-gallery-layout.css";

const HeroBanner = ({ data, onBack }) => {
    return (
        <div
            className="inspiration-hero-banner"
            style={{
                backgroundImage: data?.projectFeatureImage
                    ? `url(${data.projectFeatureImage})`
                    : undefined,
            }}
        >
            <div className="inspiration-hero-banner__overlay" />

            <div className="inspiration-hero-banner__top">
                <div className="inspiration-hero-banner__back" onClick={onBack}>
                    <ArrowLeftOutlined />
                    Back
                </div>

                {data?.projectLogo && (
                    <div className="inspiration-hero-banner__logo-wrap">
                        <Image
                            src={data.projectLogo}
                            width={46}
                            height={46}
                            preview={false}
                            style={{ objectFit: "contain" }}
                        />
                    </div>
                )}
            </div>

            <div className="inspiration-hero-banner__bottom">
                <h1 className="inspiration-hero-banner__title">{data?.projectTitle}</h1>
                {data?.tagline ? (
                    <p className="inspiration-hero-banner__tagline">{data.tagline}</p>
                ) : null}

                <div className="inspiration-hero-banner__tags">
                    <Tag color="blue">{data?.category?.name}</Tag>
                    <Tag color="gold">{data?.platform}</Tag>
                </div>
            </div>
        </div>
    );
};

export default HeroBanner;
